<div class="ldc-container">
  <div class="ldc-content">
    <div class="ldc-icon-circle">
      <i class="bi bi-trash3"></i>
    </div>

    <h2 class="ldc-title">Delete Confirmation</h2>

    <p class="ldc-line">Are you sure you want to delete this case information ?</p>
    
    <div class="ldc-warning-box" *ngIf="data.hasSharedLawyers">
      <i class="bi bi-exclamation-triangle-fill"></i>
      <p class="ldc-warning-text">
        If you proceed, this case information will be deleted and any lawyer currently viewing this case will immediately lose access.
      </p>
    </div>

    <p class="ldc-error" *ngIf="errorMessage">{{ errorMessage }}</p>

    <div class="ldc-actions">
      <button type="button" class="ldc-cancel-btn" (click)="onCancel()" [disabled]="deleting">Cancel</button>
      <button type="button" class="ldc-delete-btn" (click)="onConfirm()" [disabled]="deleting">
        {{ deleting ? 'Deleting...' : 'Delete' }}
      </button>
    </div>
  </div>
</div>